import React from 'react';

type BriteFloLogoProps = {
  className?: string;
  size?: number;
};

const BriteFloLogo: React.FC<BriteFloLogoProps> = ({ className, size = 21 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M0 7C0 3.13401 3.13401 0 7 0H13.9957C17.8617 0 20.9957 3.13401 20.9957 7V13.9957C20.9957 17.8617 17.8617 20.9957 13.9957 20.9957H7C3.13401 20.9957 0 17.8617 0 13.9957V7Z"
      fill="url(#paint0_linear_226_227)"
    />
    <path
      d="M7.49805 5.99854V11.9979"
      stroke="white"
      strokeWidth="0.9999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4974 8.99824C14.3258 8.99824 14.9973 8.32673 14.9973 7.49839C14.9973 6.67004 14.3258 5.99854 13.4974 5.99854C12.6691 5.99854 11.9976 6.67004 11.9976 7.49839C11.9976 8.32673 12.6691 8.99824 13.4974 8.99824Z"
      stroke="white"
      strokeWidth="0.9999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49839 14.9973C8.32673 14.9973 8.99824 14.3258 8.99824 13.4974C8.99824 12.6691 8.32673 11.9976 7.49839 11.9976C6.67004 11.9976 5.99854 12.6691 5.99854 13.4974C5.99854 14.3258 6.67004 14.9973 7.49839 14.9973Z"
      stroke="white"
      strokeWidth="0.9999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4976 8.99805C13.4976 10.1914 13.0235 11.3359 12.1797 12.1797C11.3359 13.0235 10.1914 13.4976 8.99805 13.4976"
      stroke="white"
      strokeWidth="0.9999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_226_227"
        x1="0"
        y1="0"
        x2="20.9957"
        y2="20.9957"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2563EB" />
        <stop offset="1" stopColor="#1D4ED8" />
      </linearGradient>
    </defs>
  </svg>
);

export default BriteFloLogo;
